import React from 'react';
import { useRouterStore } from '../../../../libs/stores';

interface DashboardHeaderProps {
  profile: string;
  firstName: string;
}
const DashboardHeader = ({profile, firstName}:DashboardHeaderProps) => {



  const getInitials = (firstName:string) => {
    return firstName
      .split(' ')
      .map(word => word[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return 'Buenos días';
    if (hour < 18) return 'Buenas tardes';
    return 'Buenas noches';
  };

  return (
    <div className="dashboard-header">
      <div className="header-info">
        <h1>{getGreeting()}, {firstName.split(' ')[0]}</h1>
        <p>Aquí tienes un resumen de tus activos y actividades recientes</p>
      </div>
      
      <div className="header-user">
        <div className="user-avatar">
          {getInitials(firstName || 'Usuario')}
        </div>
        <div className="user-details">
          <h3>{firstName}</h3>
          <span className="user-role">
            {profile === 'Administrador' ? '👨‍💼 Administrador' : '👨🏼‍💼 Cliente'}
          </span>
        </div>
      </div>
    </div>
  );
};

export default DashboardHeader;